export const firstUpperCase = (val) =>
  val ? val?.charAt(0)?.toUpperCase() + val?.slice(1) : "-";

export const mobileValidation = /^[0-9]{10}$/;

export const staticId = (page, itemsPerPage, idx) =>
  Number(page) * (itemsPerPage || 10) + (idx + 1);

export function addMinutesTo24HourTimeWithSeconds(startTime, minutesToAdd) {
  // Split the start time into hours, minutes, and seconds
  let [hours, minutes] = startTime.split(":").map(Number);

  // Create a Date object with the given time
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0); // Start with 0 seconds for clean calculations

  // Add the specified minutes
  date.setMinutes(date.getMinutes() + minutesToAdd);

  // Format the resulting time back to HH:MM:SS (24-hour format)
  const newHours = date.getHours().toString().padStart(2, "0");
  const newMinutes = date.getMinutes().toString().padStart(2, "0");
  const newSeconds = date.getSeconds().toString().padStart(2, "0");

  return `${newHours}:${newMinutes}:${newSeconds}`;
}

export function removeDuplicatesFromList(data) {
  const uniqueMap = new Map();

  data.forEach((item) => {
    if (!uniqueMap.has(item.poi_id)) {
      // Add item to the map if it doesn't exist
      uniqueMap.set(item.poi_id, item);
    } else if (item.isSelected) {
      // Update the existing item in the map if the new one has isSelected: true
      uniqueMap.set(item.poi_id, {
        ...uniqueMap.get(item.poi_id),
        isSelected: true,
      });
    }
  });

  return Array.from(uniqueMap.values());
}

export const validateIMEI = (imei) => {
  if (!/^\d{15}$/.test(imei)) return false; // Must be 15 digits

  let sum = 0;
  for (let i = 0; i < imei.length; i++) {
    let digit = parseInt(imei[i], 10);

    // Double every second digit
    if (i % 2 !== 0) digit *= 2;

    // If doubling results in a two-digit number, add the digits (e.g., 12 -> 1 + 2)
    if (digit > 9) digit -= 9;

    sum += digit;
  }

  // Valid IMEI numbers have a total sum divisible by 10
  return sum % 10 === 0;
};

export const kgToTon = (kgValue) =>
  kgValue >= 1000 ? `${kgValue / 1000} Ton` : `${kgValue} Kg`;

export const secondsToHms = (duration) => {
  const minutes = Math.floor((duration / 60) % 60);
  const seconds = Math.floor(duration % 60);
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

export const calculateBearing = (prevLocation, currentLocation) => {
  if (!prevLocation || !currentLocation) {
    return 90;
  }

  const lat1 = (prevLocation.lat * Math.PI) / 180;
  const lat2 = (currentLocation.lat * Math.PI) / 180;
  const deltaLng = ((currentLocation.lng - prevLocation.lng) * Math.PI) / 180;

  const y = Math.sin(deltaLng) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(deltaLng);

  const bearing = (Math.atan2(y, x) * 180) / Math.PI;
  const angle = (bearing + 360) % 360; // Normalize to 0–360 degrees
  return angle;
};

export const validateFileType = (file, acceptedFileTypes) => {
  // Convert acceptedFileTypes to array of valid mime types
  const validTypes = acceptedFileTypes
    .split(",")
    .map((type) => type.trim().replace("*", "."));

  // Check if file type matches any accepted type
  return validTypes.some((type) => {
    if (type.endsWith("/*")) {
      return file.type.startsWith(type.slice(0, -2));
    }
    return file.type === type || file.name.endsWith(type);
  });
};

export const isImageUrl = (url) => {
  return /\.(jpeg|jpg|gif|png|webp|bmp|svg|tiff?)$/i.test(url);
};

export const getProfileImageUrl = (file) => {
  if (typeof file !== "string") {
    return null;
  }

  const trimmed = file.trim();
  return trimmed.length > 0 ? trimmed : null;
};
